const ControlButton = ({children, indexPage}: any) => {

    const cssControlButton = (index: number) => {
        switch (index) {
            case 0: return "control-button-cvs-only";
            case 4: return "display-none";
            default: return "";
        }
    }

    const  css = `control-button-cvs mt-40 ${cssControlButton(indexPage)}`;
    return (
        <div className={css}>
            {children}
        </div>
    );
};

export {ControlButton};